module.exports = __webpack_public_path__ + "img/cityDelivery1.png";